<template>
    <div class="page">
        <section class="blk1 fz32">
          စိတ်ဝင်စားစရာဆုတွေနဲ့ ဗဟုသုတတွေရစေဖို့ Challenge Me မှာ ကစားစို့<br/>
          စမတ်ဖုန်းဆုကြီးနဲ့ အခြားဆုမဲပေါင်းများစွာကို လစဉ်ရယူလိုက်ပါ<br/>
          မှတ်ပုံတင်ရန်အတွက် ဖုန်းနံပါတ်ကို ရိုက်ထည့်ပါ<br/>
        </section>

        <div class="formbox blk3">
            <section>
                <div class="btn btn-block" @click="_loginAction('daily')">နေ့စဥ်</div>
                <div style="margin-top: 30px" class="btn btn-block" @click="_loginAction('weekly')">အပတ်စဥ်</div>
            </section>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Footer from './Footer'
export default {
    name: 'Land',
    components: {Footer},
    data(){
        return{
            mobile: '',
            passwd: ''
        }
    },
    computed: {
        ...mapState(['langMap','lang'])
    },
    created(){
      if (this.$route.query.mobile){
        this.mobile = this.$route.query.mobile;
      }
    },
    methods: {
        ...mapActions(['setUserInfo']),
        // 登录
        _loginAction(type){
            if(type == "daily"){
              window.location = "https://chm.chmemm.com/consent/page/daily";
            }else{
              window.location = "https://chm.chmemm.com/consent/page/weekly";
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .page{
        padding: 0 1em;
    }
    .blk2{
        margin-top: rem(30);
        i{
            display: inline-block;
            width: 1.2em;
            line-height: 1.2em;
            text-align: center;
            border-radius: 50%;
            background-color: rgba(255,255,255,.3);
            vertical-align: middle;
            margin-right: .8em;
        }
    }
    .blk3{
        margin-top: rem(46);
        section{
            margin-top: rem(34);
            &:first-child{
                margin-top: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/land.vue